(function($) {
    if ($(".form-list-page").length > 0) {

        var getUrlParameter = function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || "";
        }

        // Set state (+ filters from url)
        var state = {
            selectedCategories: getUrlParameter("c") !== "" ? getUrlParameter("c").split(",") : [],
            selectedTypes: getUrlParameter("t") !== "" ? getUrlParameter("t").split(",") : [],
            query: getUrlParameter("q").replace(/^\s+|\s+$/gm, "")
        };
        window.sk_form_list_page_state = state;

        // Apply filters
        var filterToUrlTimeout;
        var filter = function () {
            $(".form-list-page__link").show();
            $(".form-list-page__letter-seperator").show();

            // Update URL
            if (history.replaceState) {

                var params = "";

                if (state.query !== "")
                    params = params + "&q=" + state.query;

                if (state.selectedCategories.length)
                    params = params + "&c=" + state.selectedCategories;

                if (state.selectedTypes.length)
                    params = params + "&t=" + state.selectedTypes;

                if (params !== "")
                    params = "?" + params.substr(1);

                clearTimeout(filterToUrlTimeout);
                filterToUrlTimeout = setTimeout(function() {
                    var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + params;
                    window.history.replaceState({ path: newUrl }, '', newUrl);
                }, 200);
            }

            // Search query
            if (state.query !== "") {
                var lowerCaseQuery = state.query.toLowerCase();
                $(".form-list-page__link:not([data-title*='" + lowerCaseQuery + "'],[data-description*='" + lowerCaseQuery + "'])").each(function () {
                    $(this).hide();
                });
            }

            // Categories
            if (state.selectedCategories.length > 0) {
                var notSelector = "[data-category-" + state.selectedCategories.join("]):not([data-category-") + "]";
                $(".form-list-page__link:not(" + notSelector + ")").each(function () {
                    $(this).hide();
                });
            }

            // Types
            if (state.selectedTypes.length > 0) {
                var notSelector = "[data-type-" + state.selectedTypes.join("]):not([data-type-") + "]";
                $(".form-list-page__link:not(" + notSelector + ")").each(function () {
                    $(this).hide();
                });
            }

            // Show letter seperators for the visible links
            $(".form-list-page__letter-seperator").hide();
            $(".form-list-page__link:visible").each(function() {
                $(".form-list-page__link-letter-collection[data-first-letter='" + $(this).data("first-letter") + "'] .form-list-page__letter-seperator").show();
            });



            var totalLinks = $('.form-list-page__link').length;
            var visibleLinks = $('.form-list-page__link:visible').length;

            // Error messages
            if (visibleLinks <= 0 && totalLinks > 0) {
                $('.form-list-page__links__noresult').addClass('form-list-page__links__noresult--visible');
            } else if (totalLinks <= 0) {
                $('.form-list-page__links__nolinks').addClass('form-list-page__links__nolinks--visible');
            } else {
                $('.form-list-page__links__noresult').removeClass('form-list-page__links__noresult--visible');
                $('.form-list-page__links__nolinks').removeClass('form-list-page__links__nolinks--visible');
            }
        }

        // Update category filter state
        var updateCategoryFilter = function () {
            $('.form-list-page__category-checkbox:checked').each(function () {
                state.selectedCategories.push($(this).val());
            });
            filter();
        }

        var updateTypeFilter = function () {
            $('.form-list-page__type-checkbox:checked').each(function () {
                state.selectedTypes.push($(this).val());
            });
            filter();
        }
        
        // Hook checkboxes
        $(".form-list-page__category-checkbox").change(function () {
            state.selectedCategories = [];
            updateCategoryFilter();
        });
        $(".form-list-page__type-checkbox").change(function () {
            state.selectedTypes = [];
            updateTypeFilter();
        });

        // Hook search input query
        $(".search-filter-query").on("input", function () {
            state.query = $(this).val();
            filter();
        });

        // Prevent form submit
        $(".form-list-page__filter .form").submit(function (e) {
            e.preventDefault();
        });
        
        // On load
        if (state.query !== "" || state.selectedCategories.length > 0 || state.selectedTypes.length > 0) {
            filter();
            $(".search-filter-query").val(state.query);
            $(state.selectedCategories).each(function (index, value) {
                $('.form-list-page__category-checkbox[value="' + value + '"]').attr("checked", "checked");
            });
            $(state.selectedTypes).each(function (index, value) {
                $('.form-list-page__type-checkbox[value="' + value + '"]').attr("checked", "checked");
            });
        }

        // Categories show/hide
        $(".form-list-page__filter__toggler, .form-list-page__filter__content .btn").click(function () {
            $(".form-list-page__filter__toggle").toggleClass("form-list-page__filter__toggle--expanded");
            $(".form-list-page__filter__toggler").toggleClass("form-list-page__filter__toggler--expanded");
            $('html, body').animate({
                scrollTop: $(".form-list-page__filter__toggler").offset().top
            }, 200);
        });

    }
})(jQuery);